/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AutoUnfollowDashboardRestEndpointService {
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static updateAutoUnfollowSettings({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: Record<string, any>,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/auto-unfollow/{creatorId}',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
